import '@rainbow-me/rainbowkit/styles.css'
import { connectorsForWallets, RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { injectedWallet } from '@rainbow-me/rainbowkit/wallets'
import { WagmiProvider, createConfig, http } from 'wagmi'
import { bsc } from 'wagmi/chains'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import binanceWallet from '@binance/w3w-rainbow-connector-v2'
import { useEffect, useRef } from 'react'
import { useDisconnect } from 'wagmi'
import '../css/RainbowProvider.css'

const WALLET_CONNECT_PROJECT_ID = 'cd01d487d499c2d2524d0dea883e2b1d'
const APP_NAME = 'Binance Alpha Bot'

const recommendedWalletList = [
  {
    groupName: 'Recommended',
    wallets: [
      binanceWallet,
    ],
  },
]

const queryClient = new QueryClient()

const createProviderConfig = () => {
  const connectors = connectorsForWallets(
    recommendedWalletList,
    { projectId: WALLET_CONNECT_PROJECT_ID, appName: APP_NAME }
  )
  console.log(connectors,'connectors')
  return createConfig({
    ssr: false,
    connectors,
    chains: [bsc],
    transports: {
      [bsc.id]: http('https://bsc-dataseed.bnbchain.org',{retryCount: 5, retryDelay: 1000}),
    },
  })
}

const config = createProviderConfig()

// 内部组件用于处理断开连接逻辑
function WalletDisconnector({ children }) {
  const { disconnect } = useDisconnect()
  const hasDisconnected = useRef(false) // 变量锁，确保只执行一次

  useEffect(() => {
    // 如果已经执行过断开连接，则跳过
    if (hasDisconnected.current) {
      return
    }

    // 页面加载时断开钱包连接
    const disconnectWallet = () => {
      try {
        // 设置锁标志
        hasDisconnected.current = true
        
        // 断开当前连接
        disconnect()
        
        // 清除本地存储中的钱包连接信息
        localStorage.removeItem('wagmi.store')
        localStorage.removeItem('wagmi.connected')
        localStorage.removeItem('wagmi.wallet')
        localStorage.removeItem('wagmi.recentConnectorId')
        
        // 清除RainbowKit相关的本地存储
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('rk-')) {
            localStorage.removeItem(key)
          }
        })
        
        console.log('钱包连接已断开')
      } catch (error) {
        console.log('断开钱包连接时出错:', error)
      }
    }

    // 立即执行断开连接
    disconnectWallet()
  }, [disconnect])

  return children
}

console.log(queryClient,'queryClient')
export default function RainbowProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <WalletDisconnector>
            {children}
          </WalletDisconnector>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
